var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"updox-label",class:{ 'error-class-label': _vm.labelError }},[_c('label',{attrs:{"id":`label-${_vm.field.id}`,"for":_vm.field.id}},[_vm._v(" "+_vm._s(_vm.field.label)),(_vm.field.required)?_c('span',{staticClass:"required",class:{ 'error-class-label': _vm.labelError }},[_vm._v(" *")]):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }